import React, {Component} from 'react';
import styles from './FavIndicator.scss';
import {connect} from 'react-redux'
import MyLittleSpinner from '../../../presentational/MyLittleSpinner/MyLittleSpinner';

class FavIndicator extends Component {

    state = {
        isFavorite : false
    }

    componentDidMount() {
        let beers = this.props.favBeers.filter(beer => beer.id === this.props.id);
        //length > 0 this means beer is among favorites
        if (beers.length > 0){
            this.setState({isFavorite: true});
        }
    }

    onActivate(id) {
        if (this.props.count < 30) this.setState({isFavorite: true});
        else this.props.alertAppear();
        this.props.onActivateFav(id)
    }

    onDeactivate(id) {
        this.setState({isFavorite: false})
        this.props.onDeactivateFav(id);
        this.props.alertReset();
    }
    
    render() {
        let classes = this.state.isFavorite ? [styles.FavIndicator, styles.FavIndicatorActive] : [styles.FavIndicator];
        return (
            <div className={classes.join(' ')}
                 onMouseLeave={this.props.alertReset}>
                {this.props.processing || this.props.loading ? <MyLittleSpinner /> :
                <i onClick= {() => !this.state.isFavorite ? this.onActivate()  : this.onDeactivate()}
                   className="fas fa-heart"></i>}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        processing: state.favs.processing,
        loading: state.beer.loading,
        favBeers: state.beer.favs
    }
}

export default connect(mapStateToProps)(FavIndicator);


// WEBPACK FOOTER //
// ./src/components/containers/BeerDetails/FavIndicator/FavIndicator.js